import { BrokerLocationChargingStation } from '@energy-stacks/broker/feature-locations-data';
import { Box, Typography, useTheme } from '@mui/material';
import { ReactComponent as CSChipIcon } from './icons/locationCSChip.svg';
import { ESTooltip } from '@energy-stacks/shared';
import { useTranslation } from 'react-i18next';

interface LocationChargingStationStatusIconsProps {
  chargingStations: BrokerLocationChargingStation[];
}

export const LocationChargingStatusStationIcons: React.FC<
  LocationChargingStationStatusIconsProps
> = ({ chargingStations }) => {
  const { palette, spacing } = useTheme();
  const { t } = useTranslation('locations');
  const csCountPerStatus = chargingStations.reduce<Record<string, number>>((acc, next) => {
    acc[next.shadow] = (acc[next.shadow] ?? 0) + 1;
    return acc;
  }, {});

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 1,
        mr: 2,
        minWidth: spacing(25),
        padding: 0.8,
      }}
    >
      {Object.entries(csCountPerStatus)
        .filter(([key]) => key !== 'undefined')
        .map(([status, count]) => {
          let color: string;
          if (status === 'available') color = '#00C853';
          else if (
            status === 'occupied' ||
            status === 'preparing' ||
            status === 'charging' ||
            status === 'finishing' ||
            status === 'suspendedEV' ||
            status === 'suspendedEVSE' ||
            status === 'reserved'
          )
            color = '#1E88E5';
          else if (status === 'unavailable') color = '#4B5565';
          else if (status === 'faulted') color = '#C62828';
          else if (status === 'provisioned') color = '#E65100';
          else color = palette.text.secondary;

          return (
            <ESTooltip key={status} title={t(status, { context: 'status' })}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mr: 2,
                }}
              >
                <Typography variant="caption" color={color} sx={{ mr: 1 }}>
                  {count}
                </Typography>
                <CSChipIcon
                  stroke={color}
                  height={spacing(5)}
                  width={spacing(5)}
                />
              </Box>
            </ESTooltip>
          );
        })}
    </Box>
  );
};
